// extracted by mini-css-extract-plugin
export default {"emailBodyTextarea":"EmailTool_emailBodyTextarea__HrLzt","previewCard":"EmailTool_previewCard__etmmM"};